<template>
    <div>
        <JsonLd :json="jsonld" />
        <main id="special211101">
            <!-- 特集Specialコンテンツここから-->

            <!-- KV Section ここから -->
            <section id="kv" class="kv">
                <video-player :options="videoOptions" playsinline></video-player>
                <div id="kv__black"></div><!-- kv__black -->
            </section><!-- kv -->

            <div class="kv__titleArea">
                <p class="kv__title--sub fadeIn">Luxury Travel</p>
                <h2 class="kv__title fadeIn" id="kv__title">Nakasendo:<br>The Path to<br>a Bygone Era</h2>
                <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel02/01special')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel02/svg/play_icon.svg" alt="">Play video</p>
            </div><!-- kv__titleArea -->


            <!-- Lead Section ここから -->
            <section id="lead" class="lead">
                <div class="lead__largeImage">
                    <img src="../../../assets/luxury_travel/luxury_travel02/large_dammy.png" alt="">
                </div><!-- lead__largeImage -->
                <div class="lead__title_wrapper">
                    <h2 class="lead__title fadeIn">Explore Post Towns<br>Welcoming Travelers<br>for Centuries</h2>
                </div><!-- lead__title_wrapper -->

                <div class="lead__des_wrapper">
                    <p class="lead__des fadeIn">An ancient path cuts through the picturesque countryside of Nagano Prefecture. It’s the Nakasendo, a centuries-old mountain road that has been traveled by scores of samurai, monks, peasants, and even an emperor. Along this path, discover local shops, hidden shrines, and breathtaking views. </p>
                </div><!-- lead__des_wrapper -->

                <div class="leadPhotosArea1">
                    <img class="lead__photos01 fadeIn" src="../../../assets/luxury_travel/luxury_travel02/photos01.jpg" alt="">
                    <img class="lead__photos02 fadeIn" src="../../../assets/luxury_travel/luxury_travel02/photos02.jpg" alt="">
                </div><!-- leadPhotosArea1 -->


                <div class="lead__des_wrapper2">
                    <p class="lead__des2 fadeIn">A lifetime away from the bright lights of Tokyo, the Kiso region in Nagano Prefecture allows visitors to truly discover a Japan that is straight out of a storybook. Stone paths, wooden buildings, and quaint post-towns await those travelers lucky enough to be let in on the secret of the Kiso Valley.</p>
                </div><!-- lead__des_wrapper2 -->

                <div class="leadPhotosArea2">
                    <img class="lead__photos03 fadeIn" src="../../../assets/luxury_travel/luxury_travel02/photos03.jpg" alt="">
                </div><!-- leadPhotosArea2 -->

                <div class="lead__des_wrapper3">
                    <p class="lead__des3 fadeIn">A crossroads of luxury and history, the area allows for true historical immersion while also offering stays in some of the most exclusive traditional lodgings in the country.</p>
                </div><!-- lead__des_wrapper3 -->


            </section><!-- lead -->



            <!-- Heritage Section ここから -->
            <section class="heritage" id="heritage">

                <img class="heritage_largeImage" src="../../../assets/luxury_travel/luxury_travel02/large_dammy.png" alt="">
                <div class="heritage_titleArea">
                    <h1 class="heritage_title fadeIn" id="heritage_title">History and<br>Nature Harmonize<br>at Tsumago</h1>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel02/02heritage')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel02/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- heritage_titleArea -->
            </section><!-- heritage -->


            <section class="heritage_horizon">
                <div class="heritage_horizon_inner">
                    <div class="japanHeritageWrapper">
                        <img src="../../../assets/luxury_travel/luxury_travel02/svg/japan_heritage.svg" class="japanHeritage">
                    </div><!-- japanHeritageWrapper -->

                    <div class="photo_wrapper heritage__photos01">
                        <img src="../../../assets/luxury_travel/luxury_travel02/photos04.jpg" alt="" class="heritage__photos01_inner">
                    </div><!-- heritage__photos01 -->

                    <p class="heritage__des">A perfectly preserved post-town stands as one of the most historic and celebrated villages on the entire Nakasendo; one of two official routes stretching over 500 km between Tokyo and Kyoto. As multitudes of people traveled between the two flourishing cities, a series of post-towns were created to offer shelter and rest during the weeks-long journey. Tsumago is one of the best examples of period architecture of this era.</p>

                    <div class="photo_wrapper heritage__photos02">
                        <img src="../../../assets/luxury_travel/luxury_travel02/photos_tate01.jpg" alt="" class="heritage__photos02_inner">
                    </div><!-- heritage__photos02 -->

                    <div class="photo_wrapper heritage__photos03">
                        <img class="heritage__photos03_inner" src="../../../assets/luxury_travel/luxury_travel02/photos05.jpg" alt="">
                    </div><!-- heritage__photos03 -->

                    <p class="heritage__des2">Follow in the footsteps of samurai as you wander down the stone-paved streets, passing rows of wooden inns, shops, and houses. They quietly stretch on, the stories of millions of footsteps throughout history echoing as you walk through the area. Impossibly narrow alleyways split off from the main road, past wooden roofs heavy with weighted stones. You’re seeing what the samurai saw as they marched onward between Tokyo and Kyoto.</p>



                    <div class="photo_wrapper heritage__photos04">
                        <img class="heritage__photos04_inner" src="../../../assets/luxury_travel/luxury_travel02/photos_tate02.jpg" alt="">
                    </div><!-- heritage__photos04 -->

                    <div class="heritage__photos05">
                        <img class="heritage__photos05_inner" src="../../../assets/luxury_travel/luxury_travel02/photos_tate03.jpg" alt="">
                    </div><!-- heritage__photos05 -->

                    <p class="heritage__des3">Powerful, cascading waterfalls impress in the Kakizore Ravine. After a small hike through leafy forest, you’ll come across the ravine’s dramatic cliffscape, carved out over thousands of years by the Kakizore River. The imposing ravine is also home to Koijibashi, a 35-meter rope bridge hanging above the river’s rippling waters.</p>

                    <div class="heritage__photos06">
                        <img class="heritage__photos06_inner" src="../../../assets/luxury_travel/luxury_travel02/photos06.jpg" alt="">
                    </div><!-- heritage__photos06 -->

                    <div class="heritage__photos07">
                        <img class="heritage__photos07_inner" src="../../../assets/luxury_travel/luxury_travel02/photos07.jpg" alt="">
                    </div><!-- heritage__photos07 -->


                </div><!-- heritage_horizon_inner -->
            </section><!-- heritage_horizon -->


            <!-- Accommodation Section ここから -->
            <section class="accommodation" id="accommodation">

                <div class="accommodation__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel02/video/bg_accommodation.mp4" type="video/mp4">
                    </video>
                    <div id="accommodation__largeImage__black"></div><!-- accommodation__largeImage__black -->
                </div><!-- accommodation__largeImage -->



                <div class="accommodation__title_wrapper">
                    <h2 class="accommodation__title fadeIn">A Luxury Inn,<br>Standing Tall amongst<br>the Rice Fields</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel02/03zenagi')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel02/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- accommodation__title_wrapper -->


                <img class="accommodation_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel02/svg/accommodation.svg" alt="Accommodation">


                <div class="accomodation_section01">

                    <div class="accommodation_photo01 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel02/photos08.jpg" alt="">
                    </div><!-- accommodation_photo01 -->

                    <div class="accommodation__des_wrapper">
                        <p class="accommodation__des fadeIn">Renovated from a centuries-old <i>kominka</i> farmhouse, Zenagi is the perfect blend of history and luxury. A private, all-inclusive resort, Zenagi is perched on a hill overlooking beautiful, terraced rice fields. Built using wood from Kiso’s sacred <i>hinoki</i> cypress trees and surrounded by interlocking stone walls, the inn evokes an atmosphere of an age gone by.</p>
                    </div><!-- accommodation__des_wrapper -->


                    <div class="accommodation_photo02 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel02/photos_tate04.jpg" alt="">
                    </div><!-- accommodation_photo02 -->

                    <div class="accommodation_des02_wrapper">
                        <p class="accommodation_des02 fadeIn">The spirit of the entire Kiso region is exemplified by the understated details on display in Zenagi. The lustrous floors are glossed black by the finest local <i>urushi</i> lacquer, contrasting with the handmade <i>washi</i> paper walls. The entire building was constructed inside and out by local craftsmen without using a single nail. The exclusive inn is only available for one booking at a time.</p>
                    </div><!-- accommodation__des02_wrapper -->

                </div><!-- accomodation_section01 -->

                <div class="accommodation_largeImageArea" id="accommodation_largeImageArea">
                    <img class="accommodation_largeImage" src="../../../assets/luxury_travel/luxury_travel02/large_dammy.png" alt="">
                </div><!-- accommodation_largeImageArea -->

                <div class="accomodation_section02">

                    <div class="accommodation_des03_wrapper">
                        <p class="accommodation_des03 fadeIn">Surrounded by gentle hills and local farmhouses, a stay at Zenagi brings a unique authenticity to any visit to the area. Picturesque waterfalls, timeless villages, and the breathtaking Kakizore Ravine can all be accessed from the inn.</p>
                    </div><!-- accommodation__des03_wrapper -->

                    <div class="accommodation_photo03 fadeIn">
                        <img src="../../../assets/luxury_travel/luxury_travel02/photos09.jpg" alt="">
                        <img src="../../../assets/luxury_travel/luxury_travel02/photos10.jpg" alt="">
                    </div><!-- accommodation_photo03 -->


                </div><!-- accomodation_section02 -->

            </section><!-- accommodation -->


            <!-- Cuisine Section  ここから -->
            <section id="cuisine" class="cuisine">

                <div class="cuisine__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel02/video/bg_cuisine.mp4" type="video/mp4">
                    </video>
                    <div id="cuisine__largeImage__black"></div><!-- cuisine__largeImage__black -->
                </div><!-- cuisine__largeImage -->

                <img class="cuisine_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel02/svg/cuisine.svg" alt="Cuisine">

                <div class="cuisine__title_wrapper">
                    <h2 class="cuisine__title fadeIn">Regional Flavor,<br>Sustainably Maintained</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel02/04cuisine')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel02/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- cuisine__title_wrapper -->

                <div class="cuisine__des_wrapper">
                    <p class="cuisine__des fadeIn">The Kiso region’s cuisine is renowned throughout Japan. Famous for upholding the slow food ethos, Kiso cuisine promotes local ingredients and traditional cooking techniques while also leading the way in sustainability.</p>
                </div><!-- cuisine__des_wrapper -->

                <div class="cuisine_photo01 fadeIn">
                    <img src="../../../assets/luxury_travel/luxury_travel02/photos11.jpg" alt="">
                </div><!-- cuisine_photo01 -->

                <div class="cuisine__des02_wrapper">
                    <p class="cuisine__des02 fadeIn">Some of the country’s highest-quality ingredients – premium Kiso beef, Shinshu salmon, and matsutake mushrooms, to name a few – are grown by Kiso farmers, reflecting centuries of history and tradition. At Zenagi, meals are curated by Michelin-starred chefs with dishes ranging from a fillet of local deer, cooked to perfection and served alongside edible flowers, to delicately stewed <i>hamo</i> (daggertooth pike conger) and local mushrooms.</p>
                </div><!-- cuisine__des02_wrapper -->



                <div class="cuisine_photo02 fadeIn">
                    <img src="../../../assets/luxury_travel/luxury_travel02/photos12.jpg" alt="">
                </div><!-- cuisine_photo02 -->

                <div class="cuisine__des03_wrapper">
                    <p class="cuisine__des03 fadeIn">Each dish is carefully arranged and served upon beautiful dinnerware, meticulously crafted by local master artisans. The slow food ethos of Kiso isn’t only in the ingredients of the meal, but also in the authenticity in which it was prepared.  This means each meal served to you is a feast for all the senses, culminating in a truly unforgettable meal.</p>
                </div><!-- cuisine__des03_wrapper -->


            </section><!-- cuisine -->


            <!-- Experience Section ここから -->
            <section id="experience" class="experience">

                <div class="experience__largeImage">
                    <video playsinline autoplay muted loop>
                        <source src="../../../assets/luxury_travel/luxury_travel02/video/bg_experience.mp4" type="video/mp4">
                    </video>
                    <div id="experience__largeImage__black"></div><!-- experience__largeImage__black -->
                </div><!-- experience__largeImage -->

                <div class="experience__title_wrapper">
                    <h2 class="experience__title fadeIn">A Dramatic<br>River Valley<br>that Inspired<br>Poets and Rulers</h2>
                    <p class="playVideo fadeIn" @click="openStreaksPlayer('luxurytravel/luxurytravel02/05experience')"><img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel02/svg/play_icon.svg" alt="">Play video</p>
                </div><!-- experience__title_wrapper -->

                <div class="experience__des_wrapper">
                    <p class="experience__des fadeIn">With its steep walls and striking landscape, the imposing Kiso Gorge and the Kiso River running through it have been historically important for centuries. From days past, poets, artists, and nobles would visit the site to garner inspiration from the rugged scenery.</p>
                </div><!-- experience__des_wrapper -->

                <div class="experience__largeImage2">
                    <img src="../../../assets/luxury_travel/luxury_travel02/large_dammy.png" alt="">
                </div><!-- experience__largeImage2 -->


                <!-- Experience Horizon ここから -->
                <section class="experience_horizon">
                    <div class="experience_horizon_inner">

                        <div class="experienceTagWrapper">
                            <img src="../../../assets/luxury_travel/luxury_travel02/svg/experience.svg" class="experience_tag">
                        </div><!-- experienceTagWrapper -->

                        <div class="photo_wrapper experience__photos01">
                            <img src="../../../assets/luxury_travel/luxury_travel02/photos13.jpg" alt="" class="experience__photos01_inner">
                        </div><!-- experience__photos01 -->

                        <p class="experience__des2">These echoes of the past can almost be heard as you make your way down the river on a canoe. Paddle lazily and enjoy the calm atmosphere, or take on the rushing waves, depending on the river conditions that day. Either way, you’ll be well taken care of by an expert guide. You can also take in nature’s beauty by trekking alongside the river.</p>

                        <div class="photo_wrapper experience__photos02">
                            <img src="../../../assets/luxury_travel/luxury_travel02/photos14.jpg" alt="" class="experience__photos02_inner">
                        </div><!-- experience__photos02 -->

                        <p class="experience__des3">The river isn’t the only landscape to enjoy. Take a luxurious, authentic Japanese <i>bento</i> lunch to a bamboo forest only steps away. Rest your body and mind as you take in the river soundscape and enjoy a delectable meal served out of a traditional lacquered box. Pair it with a selection of local sake for a truly unique experience.</p>

                        <div class="photo_wrapper experience__photos03">
                            <img class="experience__photos03_inner" src="../../../assets/luxury_travel/luxury_travel02/photos_tate05.jpg" alt="">
                        </div><!-- experience__photos03 -->

                        <p class="experience__des4">Watch a master artisan at work at a local woodworking workshop. Only the Kiso area can boast having direct descendants of the originators of the art, the Ogura Clan. Craftsmen create art to be used in daily life with handmade tools and using ancestral techniques perfected by the clan over hundreds of years. Made from local, high-quality wood from the zelkova and persimmon trees, these masterworks are designed and produced with an enduring respect for, and harmony with, nature.</p>

                        <div class="photo_wrapper experience__photos04">
                            <img src="../../../assets/luxury_travel/luxury_travel02/photos15.jpg" alt="" class="experience__photos04_inner">
                        </div><!-- experience__photos04 -->


                    </div><!-- experience_horizon_inner -->
                </section><!-- experience_horizon -->

            </section><!-- experience -->


            <div class="maplinkArea">
                <a class="maplink" href="https://www.google.co.jp/maps/@0,-86.0609367,3z/data=!3m1!4b1!4m2!6m1!1s1_GP77X3O6qnTBuLNc0_opXl3HlOJjunu?hl=ja" target="_blank">See on map <img src="../../../assets/luxury_travel/luxury_travel02/svg/outerlink.svg"></a>
            </div><!-- maplinkArea -->

            <Questionnaire  :page-id="pageId"/>
            <SeeOtherLuxury />

            <!-- 特集Specialコンテンツここまで-->
            <streaks-player ref="streaks"></streaks-player>
        </main>
    </div>
</template>

<script>
import VideoPlayer from "@/components/VideoPlayer/VideoPlayer";
import StreaksPlayer from "@/components/StreaksPlayer/StreaksPlayer";
import ApiRouter from "@/components/Systems/ApiRouter";
import SeeOtherLuxury from '../SeeOtherLuxury';
import 'video.js/dist/video-js.css';
import Questionnaire from "../Questionnaire";
import JsonLd from "@/components/JsonLd/JsonLd.vue";

export default {
    name: "LuxuryTravel02",
    components: {JsonLd, Questionnaire, VideoPlayer, StreaksPlayer, SeeOtherLuxury},
    mixins: [ApiRouter],
    data: function () {
        return {
            publicPath: `${process.env.VUE_APP_PUBLIC_PATH}`,
            categoryId: '09788e7d-5beb-4d3b-b644-32d3a36f4755',
            keywords: ['temple&shrine', 'historic building', 'Buddha statue', 'food culture', 'religion', 'mountain'],
            videoOptions: {
                autoplay: 'true',
                controls: false,
                preload: 'none',
                fluid: true,
                loop: true,
                muted: true,
                sources: [
                    {
                        src:
                            `${process.env.VUE_APP_VIDEO_URL}` + "/streaks/luxurytravel/luxurytravel02/bg_main.m3u8",
                    }
                ],
            },
            pageId: '2',
            jsonld: {
                "@context": "https://schema.org",
                "@type": "Article",
                "mainEntityOfPage": window.location.href,
                "headline": "Nakasendo: The Path to a Bygone Era",
                "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                    "and other cultural assets. Find photos, videos, tourist information, and more.",
                "image": [
                    require('../../../assets/luxury_travel/index/luxury02.jpg')
                ],
                "datePublished": "2021/11/05",
                "dateModified": "2023/12/19",
                "author": [{
                    "@type": "Organization",
                    "name": "Japan National Tourism Organization",
                    "url": "https://www.japan.travel/japan-heritage/"
                }]
            }
        }
    },
    mounted: function () {
        document.title = 'Japan Heritage Official Site | Stories and travel information | JNTO'
        let url = this.publicPath + 'js/luxurytravel.js';
        let recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('src', url);
        document.head.appendChild(recaptchaScript);
    },
    methods: {
        openStreaksPlayer: function (id) {
            this.$refs.streaks.open(id);
        },
        goToStoryPage: function (id) {
            this.$router.push({name: 'Popular', params: {id: id, page: 'about'}});
        },
    }
}
</script>

<style src="./LuxuryTravel02.scss" lang="scss" scoped/>
